import React from "react";

import { ALL_PRODUCTS_OBJECT } from "./Home/CollectionHome";

const CollectionFilter = ({ collection, selectedCollection, setFilter }) => {
  const collectionTitle = typeof collection === "string" ? collection : collection?.title;
  const selectedName =
    typeof selectedCollection === "string" ? selectedCollection : selectedCollection?.title;

  const isAllSelected =
    !selectedCollection ||
    selectedCollection._id === ALL_PRODUCTS_OBJECT._id ||
    selectedName?.toLowerCase?.() === ALL_PRODUCTS_OBJECT.title;

  // By id: two collections can share a title up to case ("Shoes" / "shoes").
  const collectionId = typeof collection === "string" ? null : collection?.id || collection?._id;
  const selectedId =
    typeof selectedCollection === "string"
      ? null
      : selectedCollection?.id || selectedCollection?._id;
  const isSelected =
    !isAllSelected &&
    (collectionId && selectedId
      ? collectionId === selectedId
      : Boolean(collectionTitle) && collectionTitle === selectedName);

  const handleClick = () => {
    if (isSelected) {
      setFilter(typeof collection === "string" ? undefined : ALL_PRODUCTS_OBJECT);
      return;
    }
    setFilter(collection);
  };

  return (
    <button
      type="button"
      className={`flex shrink-0 select-none items-center justify-center whitespace-nowrap rounded-full border px-[14px] py-2.5 text-[11px] font-medium leading-none text-mutedInk transition-colors ${
        isSelected ? "border-mutedInk bg-transparent" : "border-gray-300 bg-transparent"
      }`}
      onClick={handleClick}
    >
      {collectionTitle}
    </button>
  );
};

export default CollectionFilter;
